"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[87904,42227,54392,75413,71682,68425],{

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 81301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-card-head-title {\n      display: flex;\n      align-items: center;\n      font-size: 18px;\n      font-weight: 400;\n      color: ",
        ";\n    }\n\n    .ant-card-extra {\n      font-size: 18px;\n      text-align: right;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  flex-direction: column;\n  width: ",
        ";\n\n  .ant-card-head {\n    padding: ",
        ";\n    ",
        "\n  }\n\n  .ant-card-head-title {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-card-body {\n    padding: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    "profile-config": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary)
};
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || false,
        headerBackground: props.headerBackground,
        width: props.width || "100%",
        bodyPadding: props.bodyPadding || "20px",
        headPadding: props.headPadding || "0 20px",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-5f118f4a-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var headPadding = param.headPadding;
    return headPadding;
}, function(param) {
    var headerBackground = param.headerBackground;
    return headerBackground && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), headerBackground);
}, function(param) {
    var bodyPadding = param.bodyPadding;
    return bodyPadding;
}, function(param) {
    var variant = param.variant;
    return variant && variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 70420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  border: 1px solid ',
        " !important;\n  border-color: ",
        " !important;\n  box-shadow: none !important;\n\n  :hover,\n  :focus {\n    border: 1px solid ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c892a315-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 8089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h_": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* unused harmony export MoreIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38504);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84607);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px !important;\n  border-right: none;\n  width: 256px;\n\n  li {\n    height: 30px;\n    line-height: 30px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n\n  .ant-dropdown-menu-item .ant-dropdown-menu-item-only-child {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-cd7a91fb-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var MenuItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-cd7a91fb-2"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(80));
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-3"
})(_templateObject3());
Dropdown.Menu = Menu;
Dropdown.Menu.Item = MenuItem;
Dropdown.MoreIcon = MoreIcon;
var DropdownMenu = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, Menu), {
    Item: MenuItem
});

/* harmony default export */ __webpack_exports__["ZP"] = (Dropdown);


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c038202d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n    margin: 2px;\n    border-radius: 50%;\n    border: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical,
        filled: props.filled,
        size: props.size
    };
}).withConfig({
    componentId: "sc-2aaf9a0-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, function(param) {
    var size = param.size;
    return size === "small" ? "3px" : "5px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "3px" : "5px";
}, function(param) {
    var filled = param.filled;
    return filled ? "none" : "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
}, function(param) {
    var filled = param.filled;
    return filled ? _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray : "transparent";
});
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 15807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  cursor : pointer;\n  \n  ::before {\n    content: '",
        "';\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 7%;\n    left: 7%;\n    color: ",
        ";\n    background: ",
        ";\n    border-radius: 50%;\n    min-width: 18px;\n    font-size: 12px;\n    font-weight: bold;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "icomoon";\n  font-size: ',
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "auto",
        padding: props.padding || "0px",
        newItem: props.newItem || 0,
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-793d8880-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var newItem = param.newItem;
    return newItem || "";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var Iconmoon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.attrs */ .ZP.p.attrs(function(props) {
    return {
        size: props.size || "16px",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray,
        isActive: props.isActive || false,
        hoverColor: props.hoverColor || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
        weight: props.weight || "normal"
    };
}).withConfig({
    componentId: "sc-793d8880-1"
})(_templateObject1(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(props) {
    return !props.isActive ? props.color : _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary;
}, function(props) {
    return props.hoverColor;
});

/* harmony default export */ __webpack_exports__["Z"] = (Iconmoon);


/***/ }),

/***/ 54325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n    height: 35px;\n    border: 1px solid ",
        ";\n    @media ",
        " {\n      width: 300px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    outline-color: transparent;\n    box-shadow: none;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border-color: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject()),
    withdraw: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].laptop */ .Z.laptop)
};
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "auto",
        margin: props.margin || "0",
        padding: props.padding || "5px",
        round: props.round || true,
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var round = param.round;
    return round ? "2px" : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var typeKey = param.type;
    return type[typeKey];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
Input.TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "100%",
        margin: props.margin || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-1"
})(_templateObject5(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 23906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: 0.2s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  background-color: ",
        ';\n  transition: 0.2s;\n\n  ::before {\n    content: "";\n    display: block;\n    position: absolute;\n    width: 0px;\n    height: 1px;\n    background-color: ',
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n\n  input {\n    position: inherit;\n    z-index: 1;\n    border: none;\n    background: transparent;\n  }\n\n  input::placeholder {\n    color: transparent;\n  }\n\n  input:focus {\n    outline: 0;\n  }\n\n  input:focus ~ ",
        ", input:not(:placeholder-shown) ~ ",
        " {\n    top: -20px;\n    font-size: 13px;\n  }\n\n  input:focus ~ ",
        "::before {\n    width: 100%;\n    transition: 0.5s;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    height: "28px",
    color: _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].midgray */ .Z.midgray,
    size: "16px",
    as: "label"
}).withConfig({
    componentId: "sc-c91cfec7-0"
})(_templateObject());
var Bar = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        activeColorBars: props.activeColorBar
    };
}).withConfig({
    componentId: "sc-c91cfec7-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, function(param) {
    var activeColorBar = param.activeColorBar;
    return activeColorBar || _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c91cfec7-2"
})(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, Label, Label, Bar, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props));
});
var InputContainer = function(_param) {
    var children = _param.children, className = _param.className, activeColorBar = _param.activeColorBar, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "activeColorBar"
    ]);
    var childrenProps = children.props;
    var placeholder = childrenProps.placeholder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Bar, {
                activeColorBar: activeColorBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: placeholder || " "
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputContainer);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 63757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px;\n\n  li {\n    height: 28px;\n    line-height: 28px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d17ef6e0-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d17ef6e0-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
Menu.MoreIcon = MoreIcon;
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 35266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56673);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-next {\n      border: 1px solid ",
        ";\n      a {\n        padding: 0 10px;\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      margin-right: 0;\n      border: 1px solid ",
        ";\n    }\n\n    .ant-pagination-item {\n      margin-right: 0;\n      border-radius: 0;\n      border-color: ",
        ";\n\n      a {\n        color: ",
        ";\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .ant-pagination-item-active {\n      a {\n        color: ",
        ";\n        font-weight: 600;\n      }\n      background: ",
        ";\n    }\n\n    .ant-pagination-prev:focus .ant-pagination-item-link,\n    .ant-pagination-next:focus .ant-pagination-item-link,\n    .ant-pagination-prev:hover .ant-pagination-item-link,\n    .ant-pagination-next:hover .ant-pagination-item-link {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro)
};
var Pagination = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-31bb62cf-0"
})(_templateObject2(), function(props) {
    return type[props.type];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 6305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        "\n\n  .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8dcb9882-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 50864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: none;\n  outline: 0 !important;\n\n  .selected-flag {\n    height: 35px;\n    border: 1px solid ",
        ";\n    outline: 0;\n  }\n\n  > .react-tel-input.country-list {\n    list-style: none;\n    position: absolute !important;\n    z-index: 500 !important;\n    padding: 0;\n    margin: -1px 0 0 -1px;\n    background-color: ",
        ';\n    width: 310px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n    top: 34px;\n  }\n\n  input[type="tel"] {\n    outline: 0;\n    line-height: 35px;\n    height: 35px;\n    font-weight: 300;\n    width: 100%;\n    border: none;\n    font-size: 20px;\n    position: relative;\n    border-bottom: 1px solid ',
        ';\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  input[type="tel"]:focus,\n  input[type="text"]:focus {\n    border-color: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TelephoneInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({
    componentId: "sc-dcb2dc87-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary);
/* harmony default export */ __webpack_exports__["Z"] = (TelephoneInput);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 48308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "Mt": function() { return /* reexport */ DatePicker/* default */.Z; },
  "kC": function() { return /* reexport */ Flex/* default */.Z; },
  "Bn": function() { return /* reexport */ IconMoreOptions/* default */.Z; },
  "ST": function() { return /* reexport */ Iconmoon/* default */.Z; },
  "u_": function() { return /* reexport */ Modal/* default */.Z; },
  "J2": function() { return /* reexport */ Popover/* default */.ZP; },
  "Ph": function() { return /* reexport */ Select/* default */.Z; },
  "xv": function() { return /* reexport */ Text/* default */.Z; },
  "u": function() { return /* reexport */ Tooltip/* default */.Z; }
});

// UNUSED EXPORTS: Autocomplete, Avatar, Card, Collapse, Dropdown, IconBase64, IconWrapper, Input, InputContainer, InputNumber, InputNumberContainer, Menu, Pagination, PopoverContent, PopoverContentWrapper, PopoverTitleWrapper, Radio, Steps, Table, Tabs, Tag, TelephoneInput, Textarea

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/DatePicker.js
var DatePicker = __webpack_require__(70420);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconBase64.js
var IconBase64 = __webpack_require__(37949);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputForm.js
var InputForm = __webpack_require__(23906);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputNumber.js
var InputNumber = __webpack_require__(61645);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Card.js
var Card = __webpack_require__(81301);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(93463);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/hoc/withSpacing.js
var withSpacing = __webpack_require__(97214);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Textarea.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  width: 100%;\n  resize: none;\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Textarea = (0,styled_components_browser_esm/* default */.ZP)(react_textarea_autosize_browser_esm/* default */.Z).withConfig({
    componentId: "sc-d3c3a5a9-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
/* harmony default export */ var common_Textarea = ((0,withSpacing/* default */.Z)(Textarea));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Dropdown.js
var Dropdown = __webpack_require__(8089);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/TelephoneInput.js
var TelephoneInput = __webpack_require__(50864);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Menu.js
var Menu = __webpack_require__(63757);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Checkbox.js
var Checkbox = __webpack_require__(81190);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 15 modules
var tabs = __webpack_require__(76750);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Tabs.js

function Tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .ant-tabs-nav {\n      margin: 0;\n    }\n\n    .ant-tabs-nav-list {\n      width: 100%;\n    }\n    .ant-tabs-tab {\n      margin-right: 0px !important;\n      width: 100%;\n      text-align: center;\n      display: block;\n      font-size: 16px;\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-tabs-nav .ant-tabs-nav-list {\n      border: 1px solid ",
        ";\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,\n    .ant-tabs-tab .ant-tabs-tab-active {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Tabs_templateObject()),
    "full-width": (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), color/* default.highempahis */.Z.highempahis, color/* default.whiteSmoke */.Z.whiteSmoke, color/* default.highempahis */.Z.highempahis)
};
var Tabs = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default */.Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-ccea26c3-0"
})(_templateObject2(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ var common_Tabs = ((/* unused pure expression or super */ null && (Tabs)));

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Collapse.js

function Collapse_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n\n    .ant-collapse-header {\n      color: ",
        ";\n    }\n  "
    ]);
    Collapse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Collapse_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Collapse_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var types = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Collapse_templateObject(), color/* default.light */.Z.light, color/* default.nightRider */.Z.nightRider)
};
var Collapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs(function(props) {
    return {
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-291816d3-0"
})(Collapse_templateObject1(), function(param) {
    var type = param.type;
    return types[type];
});
/* harmony default export */ var common_Collapse = ((/* unused pure expression or super */ null && (Collapse)));

// EXTERNAL MODULE: ./node_modules/antd/es/steps/index.js + 3 modules
var steps = __webpack_require__(91756);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Steps.js

function Steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-steps-item-process .ant-steps-item-icon {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    Steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Steps = (0,styled_components_browser_esm/* default */.ZP)(steps/* default */.Z).withConfig({
    componentId: "sc-8b4bf621-0"
})(Steps_templateObject(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
/* harmony default export */ var common_Steps = ((/* unused pure expression or super */ null && (Steps)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Table.js
var Table = __webpack_require__(77148);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Pagination.js
var Pagination = __webpack_require__(35266);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var Tooltip = __webpack_require__(39211);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Radio.js

function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-wrapper:hover .ant-radio,\n  .ant-radio:hover .ant-radio-inner,\n  .ant-radio-input:focus + .ant-radio-inner,\n  .ant-radio-checked .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ",
        ";\n  }\n  .ant-radio-inner::after {\n    background-color: ",
        ";\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var Radio = ((0,styled_components_browser_esm/* default */.ZP)(es_radio/* default */.ZP).withConfig({
    componentId: "sc-8f5670d5-0"
})(Radio_templateObject(), color/* default.veryLightGrey */.Z.veryLightGrey, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light));

;// CONCATENATED MODULE: ./src/@deprecated-ui/common/index.js


































/***/ }),

/***/ 50550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-close {\n    top: 20px;\n    right: 30px;\n    font-size: 14px;\n    font-weight: bold;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    border: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 40px 50px 30px;\n  }\n\n  .ant-modal-close {\n    top: 3%;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    height: 90%;\n    overflow-y: scroll;\n  }\n\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-f78b26fb-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}));


/***/ }),

/***/ 97214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var withSpacing = function(Component) {
    return function(props) {
        var spacing = (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props);
        var WithSpacingComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Component).attrs(function(componentProps) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, componentProps, spacing);
        }).withConfig({
            componentId: "sc-bfeb3364-0"
        })(_templateObject1(), function(componentProps) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(componentProps));
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WithSpacingComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withSpacing);


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 54392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ facebookIconBlue; },
/* harmony export */   "$s": function() { return /* binding */ minusIcon; },
/* harmony export */   "HM": function() { return /* binding */ googleIcon; },
/* harmony export */   "Ll": function() { return /* binding */ newChatIcon; },
/* harmony export */   "O4": function() { return /* binding */ removeIcon; },
/* harmony export */   "R7": function() { return /* binding */ plusIcon; },
/* harmony export */   "XT": function() { return /* binding */ newGoogleIcon; },
/* harmony export */   "_3": function() { return /* binding */ rightArrowIcon; },
/* harmony export */   "aq": function() { return /* binding */ stockbitIcon; },
/* harmony export */   "kn": function() { return /* binding */ adjustIcon; },
/* harmony export */   "pj": function() { return /* binding */ facebookIcon; },
/* harmony export */   "vq": function() { return /* binding */ successRegisterIcon; },
/* harmony export */   "wJ": function() { return /* binding */ pollingCloseIcon; }
/* harmony export */ });
/* unused harmony exports addPersonIcon, saveIcon, lockIcon, sortIcon, upIcon, downIcon, paperPlaneIcon */
var plusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC";
var minusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==";
var addPersonIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADhklEQVRo3uVa0W3iQBB9oPyHVICvgriDkAqgA7jvjBRSQbgOfNL8ByqIU0FMB9AB6QAq4H7eXkY+g9dk10TcShYysnf9PDNv3zzo7Pd7XMro4oLG1ak3ikgPQGq+Wqnq9pxgOk3STERGANxxXXHJB4ACwFxVi28JhiAyAP0Gc38AmLQJqluXSiKSA3g1QNYAngDcA7hR1Q6AG57/Igjw+ncRyc4eGdZEAeDWgJj6vGkRGQCYl17AIHZNdT2B/FbV1DdleF0KYMGvbgnuLGk2M0B+quq06cSqulXViQE0FJFZq2nGFHnn6YIP9KXBuhvy9IeqbtqKzMyw0TTQOhMAu9L8ccGISALgzi0aqmA5j2O1MWsyemRG/NypauiCzSrWaQVMHnohRmfJ00EbYBKnsyKldVFaJyqYfmQw/3cLICIpteHJYJJvhKcA8CoiaVMwrkDTSA/m5m1C+a7V6DUFs4rJNmbeVRs149jm1iesDXPfNnR5dDCqmpt+JLTscNJoraqtRAZGqg99WcQjKlMjk6I1a92KnXrGZgoA5l9NN97voryMIJNqqdmp3GsAxamAeF/BeXac9yxt8wTAixOeVNFZAyAzAM/m/kG5VqjS6/Y011s91bDg9qg7w0YtNyz0wZTJq9oDPtyIxd73ALJCtWUVx2rionNTwDAmxbakGspW1Bvtpu2BuecAxoGw7LxNQEZpatrfY2OBQEagiLgHvK+bz9ue5UQFu8TBAclT4Iw2bWOvmQ+ax9rFL7oFCB6ZUmo5sXhXcemSpLACULRtnl95iMOJZ9FbgEMAzyKyYzpmsfRYLRgyV4ZPV9PS8QrAhp9lak4YvZQ0fU3qHYvIkjS9aQ0MXfvHEoDs0EZZsz9NePQZtZWITGPps7/7DOsiN6kS7PcVSqPM7Pbeti831hGAtC6qls0yA2TBm4MUMCORGDU+9jXRCTr1Sc/Ofr8vi8ogZvmRN21N9PuQjNctdZXLmEBMexGlm+2SfvtmoaiDJOJA3IX0GrpGY61j0mZFDe1CO0GWANoWhxtfP6zJPrM1IZ9xt95GJICktCEHy4bOw8ND+cdYJ0FyWk8hAPTw+WcIK42CMqej5h6L8vGAeLQSBgA2VfXFYu7xSI28Kcuixp5C47a5QoKEHm8m6sFT+Zg7kxjZnx7o8Y+NtYlmKx1o55T/m5l0+oeh2qL3YGC+67iotvkPTTenKu8H9gUAAAAASUVORK5CYII=";
var saveIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9LnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qye2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qze2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PHBhdGggZD0iTTExLDJoLTFIOEg3SDRIMnYxMmgyaDhoMlY1LjZMMTEsMnogTTksM3YzSDhWM0g5eiBNNywzdjNINVYzSDd6IE01LDEzdi0zaDZ2M0g1eiBNMTMsMTNoLTFWOUg0djRIM1YzaDF2NGgzaDFoMlYzaDAuNUwxMyw1LjlWMTN6Ii8+PC9zdmc+";
var newChatIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACUklEQVRoQ+3ZwW3CMBQA0P+DyJkR2KBsUNigG5QjfB8KE7TdgErY4kY7QUeATlA6QbtB2xvi4upHGNFASIITxyCQOEASxe/72z92EM7kg2figJOBENEdAHQRsQUAc0R8HI/Hc9MRJwEhoikiduPZg4gdg/EeQkTcC9N9Q0Br/aaUavMx7yHcSCHEMwDc7sNIKSODl5DBYNBYrVYzAHhSSjEiCfMhpeQx4x/EIHhQa61/wzBsjkajnwTMUEo58g4SRwBAWym12E6prTR7kVJuJgBvUisNwcdNz/AEYFJuZ/olovf1HO2yRkZRTUMQUQsRZ1rrYRywAxFCaJcCAMiFAIAGAGwG905NMX8YiJnOXKCy9oRB1Ov1tkkvbyBFIv7NWi57pGhEJZAyEM4hZSGcQspEOIMci9hX+JJm001lL2uw2yD48T1rOSgVcixi/YAYFejKITYIbyC2CC8gRSAqhxSFqBRSJKIySNGISiBlICqBmJUlbxTE19hmZZdlPRGv2HkLtFVB7PV6zVqt9hk962zt+vFvG4TzHun3+zdBELzyjbXWizAMO7yCs0U4hxDRAyLem7RgTBAEQ60146I19qHl6aHltNPUIiLeFb9OaNDRCOc9IoT4Xkc+brFCOIWYgb6erXg3cM6pxd/JZPJluwvjLLW4fiyXy0YRjd6HdgaxjXja9RdI3gikRdT2eN72WFV228Z6U0cukAwRuKRW3ghkCKrVKXnbcxnsVuHOcLF1j2S4h9NTjtlp5Ae/K6etTL9Z4jvD+KXevJ5ONx0+42wgf0COBmCTeeVvAAAAAElFTkSuQmCC";
var stockbitIcon = "data:image/svg+xml;base64,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";
var adjustIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAYklEQVQ4y82UQQoAIAgEs/fuc/yvnYQoAyvJFrx4kB1XJBEpkaolWNNAAKZlqw9AtMIcMjO9Rd7VuIoagdtj5yAr1uoCjpDHNPMO25vm1UArzRzknTTdDr1p/ve+vKLvP3YDR+4tcGuq0dsAAAAASUVORK5CYII=";
var lockIcon = "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU4IDU4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1OCA1ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI2NHB4IiBoZWlnaHQ9IjY0cHgiPgo8Zz4KCTxwYXRoIGQ9Ik0yOSwzMGMtMi4yMDYsMC00LDEuNzk0LTQsNHY2YzAsMi4yMDYsMS43OTQsNCw0LDRzNC0xLjc5NCw0LTR2LTZDMzMsMzEuNzk0LDMxLjIwNiwzMCwyOSwzMHogTTMxLDQwYzAsMS4xMDMtMC44OTcsMi0yLDIgICBzLTItMC44OTctMi0ydi02YzAtMS4xMDMsMC44OTctMiwyLTJzMiwwLjg5NywyLDJWNDB6IiBmaWxsPSIjNmI2YjZiIi8+Cgk8cGF0aCBkPSJNNDAsMjEuMzE0VjEwLjIyQzQwLDQuNTg1LDM1LjA2NSwwLDI5LDBTMTgsNC41ODUsMTgsMTAuMjJ2MTEuMDk0QzEyLjU4NCwyNC44OTYsOSwzMS4wMzQsOSwzOGMwLDExLjAyOCw4Ljk3MiwyMCwyMCwyMCAgIHMyMC04Ljk3MiwyMC0yMEM0OSwzMS4wMzQsNDUuNDE2LDI0Ljg5Niw0MCwyMS4zMTR6IE0yMCwyMC4xNTdWMTAuMjJDMjAsNS42ODgsMjQuMDM3LDIsMjksMnM5LDMuNjg4LDksOC4yMnY5LjkzOCAgIGMtMC4xODgtMC4wOTUtMC4zOC0wLjE3OS0wLjU3LTAuMjY4Yy0wLjM5My0wLjE4NC0wLjc5Mi0wLjM1Ni0xLjE5OC0wLjUxNWMtMC4yNjEtMC4xMDItMC41MjMtMC4xOTgtMC43ODctMC4yODkgICBjLTAuMjYtMC4wODktMC41MTgtMC4xNzgtMC43ODItMC4yNTZjLTAuNDM3LTAuMTMtMC44NzktMC4yNDEtMS4zMjQtMC4zNDFjLTAuMTkzLTAuMDQzLTAuMzg3LTAuMDg0LTAuNTgyLTAuMTIyICAgYy0wLjUyMy0wLjEwMS0xLjA0OS0wLjE4My0xLjU3OS0wLjI0MmMtMC4xMi0wLjAxMy0wLjI0LTAuMDIxLTAuMzYtMC4wMzJDMzAuMjEzLDE4LjAzNiwyOS42MDgsMTgsMjksMThzLTEuMjEzLDAuMDM2LTEuODE2LDAuMDkyICAgYy0wLjEyLDAuMDExLTAuMjQxLDAuMDE5LTAuMzYsMC4wMzJjLTAuNTMsMC4wNTktMS4wNTYsMC4xNDEtMS41NzksMC4yNDJjLTAuMTk1LDAuMDM3LTAuMzg5LDAuMDc5LTAuNTgyLDAuMTIyICAgYy0wLjQ0NSwwLjEtMC44ODcsMC4yMTEtMS4zMjQsMC4zNDFjLTAuMjY0LDAuMDc4LTAuNTIzLDAuMTY4LTAuNzgyLDAuMjU2Yy0wLjI2NCwwLjA5MS0wLjUyNywwLjE4Ny0wLjc4NywwLjI4OSAgIGMtMC40MDcsMC4xNTgtMC44MDUsMC4zMzEtMS4xOTgsMC41MTVDMjAuMzgsMTkuOTc4LDIwLjE4OCwyMC4wNjIsMjAsMjAuMTU3eiBNMjksNTZjLTkuOTI1LDAtMTgtOC4wNzUtMTgtMTggICBjMC02LjUzNywzLjUxNS0xMi4yNTUsOC43NDMtMTUuNDA4YzAuOTItMC41NTQsMS44ODEtMS4wMjEsMi44NzMtMS40MDFjMC4xNzYtMC4wNjcsMC4zNTMtMC4xMzMsMC41MzEtMC4xOTUgICBjMC4yNzMtMC4wOTUsMC41NDctMC4xODYsMC44MjQtMC4yNjhjMC4zNC0wLjA5OSwwLjY4NS0wLjE4NywxLjAzMy0wLjI2NmMwLjI1NC0wLjA1OCwwLjUwOS0wLjEwOSwwLjc2NS0wLjE1NiAgIGMwLjM2OS0wLjA2NywwLjc0MS0wLjEyNywxLjExOC0wLjE3MWMwLjE3LTAuMDIxLDAuMzQxLTAuMDM5LDAuNTEyLTAuMDU0QzI3LjkyOCwyMC4wMzQsMjguNDYsMjAsMjksMjBzMS4wNzIsMC4wMzQsMS42MDEsMC4wODEgICBjMC4xNzEsMC4wMTYsMC4zNDEsMC4wMzQsMC41MTIsMC4wNTRjMC4zNzcsMC4wNDQsMC43NDksMC4xMDQsMS4xMTgsMC4xNzFjMC4yNTYsMC4wNDcsMC41MTEsMC4wOTgsMC43NjUsMC4xNTYgICBjMC4zNDgsMC4wNzksMC42OTMsMC4xNjcsMS4wMzMsMC4yNjZjMC4yNzcsMC4wODEsMC41NTEsMC4xNzMsMC44MjQsMC4yNjhjMC4xNzksMC4wNjIsMC4zNTUsMC4xMjgsMC41MzEsMC4xOTUgICBjMC45OTIsMC4zOCwxLjk1MywwLjg0NywyLjg3MywxLjQwMUM0My40ODUsMjUuNzQ1LDQ3LDMxLjQ2Myw0NywzOEM0Nyw0Ny45MjUsMzguOTI1LDU2LDI5LDU2eiIgZmlsbD0iIzZiNmI2YiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
var rightArrowIcon = "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI2OC44MzIgMjY4LjgzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY4LjgzMiAyNjguODMyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTI2NS4xNzEsMTI1LjU3N2wtODAtODBjLTQuODgxLTQuODgxLTEyLjc5Ny00Ljg4MS0xNy42NzgsMGMtNC44ODIsNC44ODItNC44ODIsMTIuNzk2LDAsMTcuNjc4bDU4LjY2MSw1OC42NjFIMTIuNSAgIGMtNi45MDMsMC0xMi41LDUuNTk3LTEyLjUsMTIuNWMwLDYuOTAyLDUuNTk3LDEyLjUsMTIuNSwxMi41aDIxMy42NTRsLTU4LjY1OSw1OC42NjFjLTQuODgyLDQuODgyLTQuODgyLDEyLjc5NiwwLDE3LjY3OCAgIGMyLjQ0LDIuNDM5LDUuNjQsMy42NjEsOC44MzksMy42NjFzNi4zOTgtMS4yMjIsOC44MzktMy42NjFsNzkuOTk4LTgwQzI3MC4wNTMsMTM4LjM3MywyNzAuMDUzLDEzMC40NTksMjY1LjE3MSwxMjUuNTc3eiIgZmlsbD0iIzZiNmI2YiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
var sortIcon = "data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw==";
var upIcon = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7";
var downIcon = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7";
var googleIcon = "data:image/svg+xml;base64,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";
var newGoogleIcon = "data:image/svg+xml;base64,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";
var facebookIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA5LjMgMTgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkuMyAxODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9DQo8L3N0eWxlPg0KPHBhdGggaWQ9ImYiIGNsYXNzPSJzdDAiIGQ9Ik02LjEsMThWOS44aDIuOGwwLjQtMy4ySDYuMXYtMkM2LjEsMy42LDYuMywzLDcuNywzbDEuNywwVjAuMUM5LjEsMC4xLDgsMCw2LjksMEM0LjQsMCwyLjgsMS41LDIuOCw0LjINCgl2Mi40SDB2My4yaDIuOFYxOEg2LjF6Ii8+DQo8L3N2Zz4NCg==";
var facebookIconBlue = "data:image/png;base64,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";
var paperPlaneIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM2QjZCNkI7fTwvc3R5bGU+PGc+PGc+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE5Ny4xLDguNGMtMC4xLTAuNS0wLjMtMC45LTAuNS0xLjNjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAtMC4xLTAuMS0wLjEtMC4yLTAuMmMtMC4yLTAuMi0wLjQtMC40LTAuNi0wLjZjLTAuMi0wLjEtMC4zLTAuMy0wLjUtMC40Yy0wLjEsMC0wLjEtMC4xLTAuMi0wLjJjLTAuMSwwLTAuMy0wLjEtMC41LTAuMmMtMC4yLTAuMS0wLjQtMC4yLTAuNi0wLjJjLTAuMywwLTAuNS0wLjEtMC44LTAuMWMtMC4yLDAtMC40LDAtMC42LDBjLTAuMywwLTAuNiwwLjEtMC44LDAuMmMtMC4xLDAtMC4zLDAtMC40LDAuMUw1LjQsODUuNmMtMi4yLDAuOS0zLjEsMy40LTIuMiw1LjZjMC40LDAuOSwxLjEsMS43LDIuMSwyLjJsNjkuNCwzMi42djY0LjljMCwyLjMsMS45LDQuMiw0LjIsNC4yYzEuNSwwLDIuOC0wLjgsMy42LTJsMjkuMy00Ny43bDQ1LjMsMjMuOWMyLjEsMS4xLDQuNiwwLjMsNS43LTEuOGMwLjItMC4zLDAuMy0wLjcsMC40LTEuMUwxOTcsMTAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTAuMywwLTAuNSwwLjEtMC43QzE5Ny4xLDguOSwxOTcuMSw4LjcsMTk3LjEsOC40eiBNNzgsMTE4LjFMMTcuNSw4OS42bDE1Ni44LTY3LjdMNzgsMTE4LjF6IE04My4xLDE3NS44di00NS42bDIxLjIsMTEuMkw4My4xLDE3NS44eiBNMTU2LjEsMTU5LjFsLTM5LjktMjFsLTcuMi00LjRsLTAuMywwLjVsLTIyLjgtMTJsOTkuNy05OS44TDE1Ni4xLDE1OS4xeiIvPjwvZz48L2c+PC9zdmc+";
var removeIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRjZFNkU7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik04LjQsMC44QzQuMywwLjgsMSw0LjEsMSw4LjFzMy4zLDcuNCw3LjQsNy40czcuNC0zLjMsNy40LTcuNFMxMi40LDAuOCw4LjQsMC44eiBNMTEuMSw4LjZINS42VjcuN2g1LjVWOC42eiINCgkvPg0KPC9zdmc+DQo=";
var pollingCloseIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMi4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNFOUU5RTk7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yMCw5LjlDMTkuOSw0LjQsMTUuNC0wLjEsOS45LDBDNC40LDAuMS0wLjEsNC42LDAsMTAuMWMwLjEsNS41LDQuNiwxMCwxMC4xLDkuOUMxNS42LDE5LjksMjAuMSwxNS40LDIwLDkuOXoNCgkgTTEyLjgsMTMuNUwxMCwxMC43bC0yLjgsMi44bC0wLjctMC43TDkuMywxMEw2LjUsNy4ybDAuNy0wLjdMMTAsOS4zbDIuOC0yLjhsMC43LDAuN0wxMC43LDEwbDIuOCwyLjhMMTIuOCwxMy41eiIvPg0KPC9zdmc+DQo=";
var successRegisterIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM2QjZCNkI7fTwvc3R5bGU+PGc+PGc+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE5Ny4xLDguNGMtMC4xLTAuNS0wLjMtMC45LTAuNS0xLjNjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAtMC4xLTAuMS0wLjEtMC4yLTAuMmMtMC4yLTAuMi0wLjQtMC40LTAuNi0wLjZjLTAuMi0wLjEtMC4zLTAuMy0wLjUtMC40Yy0wLjEsMC0wLjEtMC4xLTAuMi0wLjJjLTAuMSwwLTAuMy0wLjEtMC41LTAuMmMtMC4yLTAuMS0wLjQtMC4yLTAuNi0wLjJjLTAuMywwLTAuNS0wLjEtMC44LTAuMWMtMC4yLDAtMC40LDAtMC42LDBjLTAuMywwLTAuNiwwLjEtMC44LDAuMmMtMC4xLDAtMC4zLDAtMC40LDAuMUw1LjQsODUuNmMtMi4yLDAuOS0zLjEsMy40LTIuMiw1LjZjMC40LDAuOSwxLjEsMS43LDIuMSwyLjJsNjkuNCwzMi42djY0LjljMCwyLjMsMS45LDQuMiw0LjIsNC4yYzEuNSwwLDIuOC0wLjgsMy42LTJsMjkuMy00Ny43bDQ1LjMsMjMuOWMyLjEsMS4xLDQuNiwwLjMsNS43LTEuOGMwLjItMC4zLDAuMy0wLjcsMC40LTEuMUwxOTcsMTAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTAuMywwLTAuNSwwLjEtMC43QzE5Ny4xLDguOSwxOTcuMSw4LjcsMTk3LjEsOC40eiBNNzgsMTE4LjFMMTcuNSw4OS42bDE1Ni44LTY3LjdMNzgsMTE4LjF6IE04My4xLDE3NS44di00NS42bDIxLjIsMTEuMkw4My4xLDE3NS44eiBNMTU2LjEsMTU5LjFsLTM5LjktMjFsLTcuMi00LjRsLTAuMywwLjVsLTIyLjgtMTJsOTkuNy05OS44TDE1Ni4xLDE1OS4xeiIvPjwvZz48L2c+PC9zdmc+";


/***/ }),

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ APIErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
;// CONCATENATED MODULE: ./src/config/APIErrorMessage/handler.js





/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    // Some API chat with 'blokir' message and 'FORBIDDEN' error_type should show alert
    // remove this block whenever BE possible to change error_type from 'FORBIDDEN'
    if (message.includes("blokir")) {
        var errMessageDefault = message;
        (0,AlertErrorMessage/* default */.Z)(errMessageDefault, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        return;
    }
    /// ///////////////////////////////////////////////////
    if (errorType === errorMessage/* default.PAYWALL_NOSUBSCRIPTION */.Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === errorMessage/* default.FORBIDDEN */.Z.FORBIDDEN) return;
    var errMessageDefault1 = message;
    (0,AlertErrorMessage/* default */.Z)(errMessageDefault1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,utils/* dispatchSetErrorCode */.S)(503, message);
    }
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(errorType, message) {
    if (errorType === "INVALID_RECAPTCHA") {
        return;
    }
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,utils/* dispatchSetErrorCode */.S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * @deprecated 401 Unathorized is directly handled from API instance
 * handleUnAuthorized
 * @param {Promise} originalRequest
 * @return Promise originalRequest with new Authorization header or error rejection
 */ // eslint-disable-next-line @typescript-eslint/no-empty-function
var handleUnAuthorized = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(originalRequest) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleUnAuthorized(originalRequest) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var handler = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleInvalidParameter: handleInvalidParameter,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleInternalServerError: handleInternalServerError
});

;// CONCATENATED MODULE: ./src/config/APIErrorMessage/index.js

var APIErrorMessage_handleDefault = handler.handleDefault, APIErrorMessage_handleMaintenance = handler.handleMaintenance, APIErrorMessage_handleInvalidParameter = handler.handleInvalidParameter, APIErrorMessage_handleNotFound = handler.handleNotFound, APIErrorMessage_handleNotSubscription = handler.handleNotSubscription, APIErrorMessage_handleUnAuthorized = handler.handleUnAuthorized, APIErrorMessage_handleInternalServerError = handler.handleInternalServerError;
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: APIErrorMessage_handleDefault,
        400: APIErrorMessage_handleInvalidParameter,
        401: APIErrorMessage_handleUnAuthorized,
        402: APIErrorMessage_handleNotSubscription,
        404: APIErrorMessage_handleNotFound,
        500: APIErrorMessage_handleInternalServerError,
        503: APIErrorMessage_handleMaintenance
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ var APIErrorMessage = ({
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 14350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getAccessTokenDataFn; },
/* harmony export */   "oD": function() { return /* binding */ getRefreshTokenConfigFn; },
/* harmony export */   "x5": function() { return /* binding */ refreshExodusToken; }
/* harmony export */ });
/* unused harmony export initialRefreshTokenConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19225);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);





var initialRefreshTokenConfig = {
    refreshingTokenStatus: "initial",
    refreshAndRetryQueue: []
};
var getRefreshTokenConfigFn = function() {
    var initNewConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (true) {
        if (initNewConfig) {
            window.refreshRequestConfig = {
                refreshingTokenStatus: "initial",
                refreshAndRetryQueue: []
            };
            return window.refreshRequestConfig;
        }
        if (typeof window.refreshRequestConfig !== "undefined") {
            return window.refreshRequestConfig;
        }
        return undefined;
    }
    return initialRefreshTokenConfig;
};
var getAccessTokenDataFn = function() {
    var ref, ref1, ref2, ref3;
    var parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
    var accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token) || "";
    var accessTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.expiry) || 0;
    var refreshToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref2 = parsedToken.refresh) === null || ref2 === void 0 ? void 0 : ref2.token) || "";
    var refreshTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref3 = parsedToken.refresh) === null || ref3 === void 0 ? void 0 : ref3.expiry) || 0;
    return {
        accessToken: accessToken,
        accessTokenExpiry: accessTokenExpiry,
        refreshToken: refreshToken,
        refreshTokenExpiry: refreshTokenExpiry
    };
};
var refreshExodusToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, parsedToken, refreshToken, response, _data, newAccessTokenData, parsedAccessExpired, parsedRefreshExpired;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    refreshToken = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.refresh) === null || ref === void 0 ? void 0 : ref.token;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
                        headers: {
                            Authorization: "Bearer ".concat(refreshToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (!(!response || !response.data || !response.data.data)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 8:
                    _data = response.data, newAccessTokenData = _data.data;
                    parsedAccessExpired = new Date(newAccessTokenData.access.expired_at).getTime();
                    parsedRefreshExpired = new Date(newAccessTokenData.refresh.expired_at).getTime();
                    utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].saveToken */ .Z.saveToken({
                        accessToken: newAccessTokenData.access.token,
                        accessTokenExp: parsedAccessExpired,
                        refreshToken: newAccessTokenData.refresh.token,
                        refreshTokenExp: parsedRefreshExpired,
                        accessUser: utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess()
                    });
                    return _ctx.abrupt("return", newAccessTokenData.access.token);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshExodusToken() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ config_requestExodus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/config/refreshToken/index.ts
/* eslint-disable no-param-reassign */ 

var generateNewRequestWithRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var apiInstance, axiosError, getRefreshTokenConfig, getAccessTokenData, refreshTokenPromise, refreshTokenConfig, dateNow, newAccessToken, newRequest;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiInstance = param.apiInstance, axiosError = param.axiosError, getRefreshTokenConfig = param.getRefreshTokenConfig, getAccessTokenData = param.getAccessTokenData, refreshTokenPromise = param.refreshTokenPromise;
                    refreshTokenConfig = getRefreshTokenConfig();
                    dateNow = Math.floor(Date.now() / 1000);
                    _ctx.prev = 3;
                    if (!(dateNow > getAccessTokenData().refreshTokenExpiry)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 6:
                    if (!(typeof refreshTokenConfig === "undefined" || // Previous success refresh token config need to reset
                    (refreshTokenConfig.refreshingTokenStatus === "success" && dateNow > getAccessTokenData().accessTokenExpiry))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", generateNewRequestWithRefreshToken({
                        apiInstance: apiInstance,
                        axiosError: axiosError,
                        getAccessTokenData: getAccessTokenData,
                        refreshTokenPromise: refreshTokenPromise,
                        getRefreshTokenConfig: function() {
                            return getRefreshTokenConfig(true);
                        }
                    }));
                case 8:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "initial")) {
                        _ctx.next = 22;
                        break;
                    }
                    refreshTokenConfig.refreshingTokenStatus = "processing";
                    ;
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return refreshTokenPromise();
                case 14:
                    newAccessToken = _ctx.sent;
                    refreshTokenConfig.refreshingTokenStatus = "success";
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](11);
                    throw new Error("Failed Refresh Token");
                case 21:
                    // After refresh token API call success,
                    // proceed every API call within queue
                    refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var config, resolve, newRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        config = param.config, resolve = param.resolve;
                                        config.headers.Authorization = "Bearer ".concat(newAccessToken);
                                        _ctx.prev = 2;
                                        _ctx.next = 5;
                                        return apiInstance.request(config);
                                    case 5:
                                        newRequest = _ctx.sent;
                                        resolve(newRequest);
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](2);
                                        throw new Error("Failed API call after success refresh token");
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    2,
                                    9
                                ]
                            ]);
                        }));
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 22:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "success")) {
                        _ctx.next = 30;
                        break;
                    }
                    if (!(axiosError.config.headers.Authorization === "Bearer ".concat(getAccessTokenData().accessToken))) {
                        _ctx.next = 25;
                        break;
                    }
                    throw new Error("Token Alreadry Refreshed");
                case 25:
                    // Proceed new incoming API call with new API token
                    axiosError.config.headers.Authorization = "Bearer ".concat(getAccessTokenData().accessToken);
                    _ctx.next = 28;
                    return apiInstance.request(axiosError.config);
                case 28:
                    newRequest = _ctx.sent;
                    return _ctx.abrupt("return", newRequest);
                case 30:
                    if (refreshTokenConfig.refreshingTokenStatus === "failed") {
                        refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, index) {
                                var reject;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            reject = param.reject;
                                            reject(axiosError);
                                            if (index === refreshTokenConfig.refreshAndRetryQueue.length - 1) {
                                                refreshTokenConfig.refreshAndRetryQueue = [];
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_, index) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    }
                    _ctx.next = 37;
                    break;
                case 33:
                    _ctx.prev = 33;
                    _ctx.t1 = _ctx["catch"](3);
                    if (typeof refreshTokenConfig !== "undefined") {
                        refreshTokenConfig.refreshingTokenStatus = "failed";
                    }
                    return _ctx.abrupt("return", Promise.reject(_ctx.t1));
                case 37:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        getRefreshTokenConfig().refreshAndRetryQueue.push({
                            config: axiosError.config,
                            resolve: resolve,
                            reject: reject
                        });
                    }));
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                33
            ],
            [
                11,
                18
            ]
        ]);
    }));
    return function generateNewRequestWithRefreshToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var refreshToken = (generateNewRequestWithRefreshToken);

// EXTERNAL MODULE: ./src/config/refreshToken/exodus.ts
var exodus = __webpack_require__(14350);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestExodus.ts















var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_object_spread/* default */.Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "User-Agent": api/* CUSTOM_USER_AGENT */.GV
        });
    }
    var apiInstance = axios_default().create({
        baseURL: api/* API_EXODUS_URL */.q7,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref, ref1;
        var requestFromBrowser = (0,app/* isClient */.C5)();
        if (!requestFromBrowser) {
            return request;
        }
        if (!(window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine)) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.OFFLINE */.Z.OFFLINE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return Promise.reject(errorMessage/* default.OFFLINE */.Z.OFFLINE);
        }
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (request.url !== "/user/setting/password/reset" && token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var responseRetrieveFromBrowser, _data, errorType, _message, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 3:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? errorMessage/* default.DEFAULT_ERROR_MESSAGE */.Z.DEFAULT_ERROR_MESSAGE : _message;
                        if (!(errorType && isShowAlertMessage)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        throw message;
                    case 7:
                        return _ctx.abrupt("return", response);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosError) {
            var ref, ref1, ref2, ref3, responseRetrieveFromBrowser, newRequest, _response, status, data, message, errorType, errors, parsedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 4:
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 6:
                        //-------------------------------------------
                        // Error Logger
                        (0,logger/* sentryLog */.gB)({
                            scope: "server-layer",
                            level: "info",
                            httpStatusCode: (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status,
                            tags: [
                                {
                                    title: "api-error-url",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.request) === null || ref1 === void 0 ? void 0 : ref1.responseURL
                                },
                                {
                                    title: "api-error-text",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref2 = axiosError.request) === null || ref2 === void 0 ? void 0 : ref2.responseText
                                }, 
                            ],
                            error: new Error(axiosError.message)
                        });
                        if (![
                            401
                        ].includes((ref3 = axiosError.response) === null || ref3 === void 0 ? void 0 : ref3.status)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return refreshToken({
                            apiInstance: apiInstance,
                            axiosError: axiosError,
                            getRefreshTokenConfig: exodus/* getRefreshTokenConfigFn */.oD,
                            getAccessTokenData: exodus/* getAccessTokenDataFn */.RL,
                            refreshTokenPromise: exodus/* refreshExodusToken */.x5
                        });
                    case 11:
                        newRequest = _ctx.sent;
                        return _ctx.abrupt("return", newRequest);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        (0,utils/* dispatchSetErrorCode */.S)(401);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                        _response = axiosError.response, status = _response.status, data = _response.data;
                        message = data === null || data === void 0 ? void 0 : data.message;
                        errorType = data === null || data === void 0 ? void 0 : data.error_type;
                        errors = (data === null || data === void 0 ? void 0 : data.errors) || [];
                        // Some error message is unparsed in `message`
                        if (!errorType) {
                            parsedMessage = JSON.parse(message);
                            message = parsedMessage.message;
                            errorType = parsedMessage.error_type;
                        }
                        if (isShowAlertMessage) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 26:
                        APIExodusErrorHandler(status, errorType, message);
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        //-------------------------------------------
        }));
        return function(axiosError) {
            return _ref.apply(this, arguments);
        };
    }());
    return apiInstance;
}
/* harmony default export */ var config_requestExodus = (requestExodus);


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_RECAPTCHA: "INVALID_RECAPTCHA",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Success Report User",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 35497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ GuestPostWrapper; },
/* harmony export */   "X": function() { return /* binding */ PostWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  border-bottom: none;\n  margin: auto;\n  max-width: 660px;\n\n  > div {\n    border-bottom: 1px solid #dadada!important;\n  }\n\n  @media ",
        " {\n    max-width: 1000px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div {\n    padding: 0px;\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PostWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-74fe3694-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__/* ["default"].laptop */ .Z.laptop);
var GuestPostWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-74fe3694-1"
})(_templateObject1());



/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 63576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ PAGE_SOURCE_INDEX; },
/* harmony export */   "j4": function() { return /* binding */ mainProfileEvents; },
/* harmony export */   "nP": function() { return /* binding */ PAGE_SOURCE; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var PAGE_SOURCE;
(function(PAGE_SOURCE) {
    PAGE_SOURCE["streamPost"] = "Stream Post";
    PAGE_SOURCE["streamLikeList"] = "Stream Like List";
    PAGE_SOURCE["companyPage"] = "Company Page";
    PAGE_SOURCE["chat"] = "Chat";
    PAGE_SOURCE["search"] = "Search";
    PAGE_SOURCE["discoverPeople"] = "Discover People";
    PAGE_SOURCE["followers"] = "Followers";
    PAGE_SOURCE["following"] = "Following";
})(PAGE_SOURCE || (PAGE_SOURCE = {}));
var PAGE_SOURCE_INDEX = [
    "Stream Post",
    "Stream Like List",
    "Company Page",
    "Chat",
    "Search",
    "Discover People",
    "Followers",
    "Following",
    "My Profile",
    "Group Chat Bottom Sheet", 
];
var mainProfileEvents = {
    onViewProfile: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Stream View Profile", {
            "Page Source": pageSource
        });
    },
    onUserProfileViewed: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Viewed", {
            "Page Source": pageSource
        });
    },
    onUserProfileChatSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Chat Selected");
    },
    onUserProfileFollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Follow Selected");
    },
    onUserProfileUnfollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unfollow Selected");
    },
    onUserProfileTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn On Alert");
    },
    onUserProfileComposePost: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Compose Post");
    },
    onUserProfileAddorRemovefromWatchlist: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist");
    },
    onUserProfileBlock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block");
    },
    onUserProfileSuccessfullyTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn on alert");
    },
    onComposePostViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Compose Post Viewed");
    },
    onUserProfileAddOrRemoveFromWatchlistViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist Viewed");
    },
    onUserProfileBlockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block Confirmed");
    },
    onUserProfileSuccessfullyBlocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Blocked");
    },
    onUserProfileTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn Off Alert");
    },
    onUserProfileSuccessfullyTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn Off Alert");
    },
    onUserProfileUnblock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock");
    },
    onUserProfileUnblockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock Confirmed");
    },
    onUserProfileSuccessfullyUnblocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Unblock");
    }
};


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1624a33f-0"
})(_templateObject(), color/* default.primary */.Z.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ 







/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                size: "14px",
                className: "icon-toolbar_check",
                color: color/* default.light */.Z.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
    return null;
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 14467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);




var initialState = {
    activeModal: undefined,
    modalProps: {}
};
var useGlobalModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setActiveModal: function(activeModal, props) {
            set({
                activeModal: activeModal
            });
            if (activeModal) {
                get().setModalProps(activeModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                    onCancel: function() {
                        if (!(props === null || props === void 0 ? void 0 : props.preventClose)) get().setActiveModal();
                        if (props === null || props === void 0 ? void 0 : props.onCancel) props.onCancel();
                    }
                }));
            }
        },
        setModalProps: function(type, props) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produce */ .Uy)(function(state) {
                state.modalProps[type] = props;
            }));
        },
        resetActiveModal: function() {
            return set({
                activeModal: undefined
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalModalStore);


/***/ }),

/***/ 30682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ GlobalModalType; }
/* harmony export */ });
var GlobalModalType;
(function(GlobalModalType) {
    GlobalModalType["FastOrder"] = "fastOrder";
    GlobalModalType["ChatLimit"] = "chatLimit";
})(GlobalModalType || (GlobalModalType = {}));


/***/ }),

/***/ 37842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39211);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79644);







var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function GreenVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Verified Account"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: URL_VERIFICATION_ARTICLE,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Pelajari Lebih Lanjut"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/widget-trending/icon-verified.svg",
            style: {
                width: "12px",
                marginLeft: 5
            },
            alt: "icon-verified"
        })
    });
}
function GreyVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: "#858585",
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Account Verified"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Identitas user telah terverifikasi sebagai nasabah Stockbit Sekuritas"
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/verified-grey.svg",
            style: {
                width: "12px",
                marginLeft: 4
            },
            alt: "icon-verified"
        })
    });
}
function LabelVerifiedAccount(param) {
    var deprecatedVerifiedStatus = param.deprecatedVerifiedStatus, verifiedStatus = param.verifiedStatus;
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_COMMUNITY */ .P.VERIFIED_STATUS_COMMUNITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_IDENTITY */ .P.VERIFIED_STATUS_IDENTITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreyVerifiedBadge, {});
    }
    if (deprecatedVerifiedStatus && verifiedStatus === undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (LabelVerifiedAccount);


/***/ }),

/***/ 94493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SH": function() { return /* reexport */ Labels_LabelAdmin; },
  "QP": function() { return /* reexport */ Labels_LabelTopUser; },
  "uC": function() { return /* reexport */ LabelVerifiedAccount/* default */.Z; }
});

// UNUSED EXPORTS: LabelPro, LabelSuspended, LabelVerified

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var common_Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var common_Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var _style_color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/utils/userRole.js
var userRole = __webpack_require__(58080);
;// CONCATENATED MODULE: ./src/global/Labels/LabelAdmin.tsx





function LabelAdmin(param) {
    var privilege = param.privilege;
    if ((0,userRole/* getUserRole */.Rg)(privilege)) {
        return(// @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: (0,userRole/* getUserRole */.Rg)(privilege)
            })
        }));
    }
    return null;
}
/* harmony default export */ var Labels_LabelAdmin = (LabelAdmin);

;// CONCATENATED MODULE: ./src/global/Labels/LabelPro.tsx




function LabelPro() {
    return(// @ts-expect-error
    /*#__PURE__*/ _jsx(Button, {
        p: "0px",
        margin: "0 2px",
        round: true,
        children: /*#__PURE__*/ _jsx(Text, {
            size: "10px",
            color: color.suvaGrey,
            padding: "2px",
            children: "PRO"
        })
    }));
}
/* harmony default export */ var Labels_LabelPro = ((/* unused pure expression or super */ null && (LabelPro)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/global/Labels/LabelSuspended.tsx



var LabelSuspended_Tag = Tag/* default.Tag */.Z.Tag;
function LabelSuspended() {
    return /*#__PURE__*/ _jsx(LabelSuspended_Tag, {
        style: {
            borderColor: color.sunsetOrange,
            color: color.sunsetOrange,
            fontWeight: "bold"
        },
        children: "Suspended"
    });
}
/* harmony default export */ var Labels_LabelSuspended = ((/* unused pure expression or super */ null && (LabelSuspended)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var common_Tooltip = __webpack_require__(39211);
;// CONCATENATED MODULE: ./src/global/Labels/LabelTopUser.tsx





function LabelTopUser() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Tooltip/* default */.Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Stockbit top users"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: "TOP"
            })
        })
    });
}
/* harmony default export */ var Labels_LabelTopUser = (LabelTopUser);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var common_Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/Labels/LabelVerified.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/jsx-wrap-multilines */ 




var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function LabelVerified() {
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: "rightTop",
        autoAdjustOverflow: true,
        overlayInnerStyle: {
            background: "rgba(64, 64, 64, 0.85)"
        },
        title: /*#__PURE__*/ _jsxs("p", {
            style: {
                marginBottom: 0
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    family: "bold",
                    color: color.light,
                    size: "12px",
                    style: {
                        lineHeight: "1.5"
                    },
                    children: "Verified Account"
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    color: color.light,
                    size: "12px",
                    height: "1.5",
                    children: [
                        "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.",
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                color: color.primary,
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return window.open(URL_VERIFICATION_ARTICLE);
                            },
                            children: "Pelajari Lebih Lanjut"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(IconWrapper, {
            padding: "0 4px",
            children: /*#__PURE__*/ _jsx(Iconmoon, {
                className: "icon-custom_verified-circle",
                size: "12px",
                color: color.primary
            })
        })
    });
}
/* harmony default export */ var Labels_LabelVerified = ((/* unused pure expression or super */ null && (LabelVerified)));

// EXTERNAL MODULE: ./src/global/Labels/LabelVerifiedAccount.tsx
var LabelVerifiedAccount = __webpack_require__(37842);
;// CONCATENATED MODULE: ./src/global/Labels/index.tsx








/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      transform: rotate(360deg);\n      opacity: 1;\n    }\n  }\n\n  > div {\n    display: block;\n    margin: auto;\n    height: ",
        ";\n    width: ",
        ";\n    animation: rotate 0.8s infinite linear;\n    border-radius: 50%;\n    border: solid 1.5px ",
        ";\n    border-right-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// eslint-disable-next-line space-infix-ops
var SecondarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bfa5182-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#6b6b6b";
});
var SecondarySpinner = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? "18px" : _size, text = _param.text, _color = _param.color, color = _color === void 0 ? "#6b6b6b" : _color, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "size",
        "text",
        "color",
        "isLoading"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            direction: "column",
            justify: "center",
            align: "center"
        }, props), {
            "data-cy": "global-loading-spinner-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondarySpinnerDiv, {
                    size: size,
                    color: color,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: text,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        family: "light",
                        padding: "20px 0 0 0",
                        children: text
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondarySpinner);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 64355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ PageWrapper; },
/* harmony export */   "In": function() { return /* binding */ ButtonCTA; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "b0": function() { return /* binding */ UserNotFoundContainer; },
/* harmony export */   "hV": function() { return /* binding */ PostNotFoundContainer; },
/* harmony export */   "yD": function() { return /* binding */ ButtonBackHome; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 20px;\n  flex-direction: column;\n\n  > img {\n    width: 40%;\n    align-self: flex-end;\n  }\n\n  ",
        " {\n    width: calc(100%);\n    flex-direction: column;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n    > img {\n      margin-right: 50px;\n      width: 200px;\n    }\n    ",
        " {\n      width: auto;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 50px);\n  margin: 100px auto;\n  height: calc(100vh - 150px);\n  @media ",
        " {\n    max-width: 1300px;\n    width: calc(100% - 150px);\n    margin: 150px auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 375px;\n  padding: 20px;\n  background: ",
        ";\n\n  img {\n    width: 160px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 16px;\n  font-family: var(--font-bold);\n  border-radius: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #FFFFFF;\n  border: 1px solid #DADADA;\n  width: 668px;\n  padding-top: 62px;\n  padding-bottom: 62px;\n  border-radius: 2px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12.5px 16px;\n  background: #00AB6B;\n  color: #FFFFFF;\n  font-weight: bold;\n  font-family: var(--font-bold);\n  border-radius: 4px;\n  margin-top: 40px;\n\n  :active, :hover {\n    color: #FFFFFF;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var PageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2247e248-0"
})(_templateObject(), _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].laptop */ .Z.laptop, _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-2247e248-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var PostNotFoundContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    direction: "column"
}).withConfig({
    componentId: "sc-2247e248-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
var ButtonCTA = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    type: "primary",
    mt: "28px",
    width: "100%"
}).withConfig({
    componentId: "sc-2247e248-3"
})(_templateObject3());
var UserNotFoundContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-2247e248-4"
})(_templateObject4());
var ButtonBackHome = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-2247e248-5"
})(_templateObject5());



/***/ }),

/***/ 6474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ getCashInfo; },
  "S": function() { return /* binding */ getCashOnHand; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/global/Securities/constants/apiEndpoints/balance.ts
var balanceEndpoint = {
    cashInfo: "/balance/cash/info",
    cashOnHand: "/balance/cash"
};
/* harmony default export */ var balance = (balanceEndpoint);

// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/balance.ts




var getCashInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode, orderId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashInfo, {
                        params: {
                            stock_code: stockCode,
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashInfo(stockCode, orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getCashOnHand = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashOnHand));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashOnHand() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 75626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ OrderAction; }
/* harmony export */ });
/* unused harmony export OrderStatus */
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));


/***/ }),

/***/ 91037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ActionTarget; },
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "IC": function() { return /* binding */ OrderSecuritiesKindType; },
/* harmony export */   "Wv": function() { return /* binding */ OrderLeverageType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "l5": function() { return /* binding */ ForcedSellMapper; },
/* harmony export */   "oU": function() { return /* binding */ OrderSide; },
/* harmony export */   "pD": function() { return /* binding */ OrderForceSellType; },
/* harmony export */   "pY": function() { return /* binding */ SecuritiesKind; },
/* harmony export */   "vT": function() { return /* binding */ iOrderSide; }
/* harmony export */ });
/* unused harmony export OrderStatus */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var SecuritiesKind;
(function(SecuritiesKind) {
    SecuritiesKind[SecuritiesKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SecuritiesKind[SecuritiesKind["STOCK"] = 1] = "STOCK";
    SecuritiesKind[SecuritiesKind["BOND"] = 2] = "BOND";
})(SecuritiesKind || (SecuritiesKind = {}));
var OrderSecuritiesKindType;
(function(OrderSecuritiesKindType) {
    OrderSecuritiesKindType["Unspecified"] = "SECURITIES_KIND_UNSPECIFIED";
    OrderSecuritiesKindType["Stock"] = "SECURITIES_KIND_STOCK";
    OrderSecuritiesKindType["Bond"] = "SECURITIES_KIND_BOND";
})(OrderSecuritiesKindType || (OrderSecuritiesKindType = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var iOrderSide;
(function(iOrderSide) {
    iOrderSide[iOrderSide["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    iOrderSide[iOrderSide["BUY"] = 1] = "BUY";
    iOrderSide[iOrderSide["SELL"] = 2] = "SELL";
})(iOrderSide || (iOrderSide = {}));
var OrderSide;
(function(OrderSide) {
    OrderSide["Unspecified"] = "SIDE_UNSPECIFIED";
    OrderSide["Buy"] = "SIDE_BUY";
    OrderSide["Sell"] = "SIDE_SELL";
})(OrderSide || (OrderSide = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));
var OrderForceSellType;
(function(OrderForceSellType) {
    OrderForceSellType["Unspecified"] = "DAY_TRADE_FORCE_SELL_UNSPECIFIED";
    OrderForceSellType["DebtRatio"] = "DAY_TRADE_FORCE_SELL_DEBT_RATIO";
    OrderForceSellType["TimeLimit"] = "DAY_TRADE_FORCE_SELL_TIME_LIMIT";
})(OrderForceSellType || (OrderForceSellType = {}));
var OrderLeverageType;
(function(OrderLeverageType) {
    OrderLeverageType["Unspecified"] = "LEVERAGE_TYPE_TRADING_UNSPECIFIED";
    OrderLeverageType["TradingBalance"] = "LEVERAGE_TYPE_TRADING_BALANCE";
    OrderLeverageType["TradingLimit"] = "LEVERAGE_TYPE_TRADING_LIMIT";
    OrderLeverageType["BasicLimit"] = "LEVERAGE_TYPE_BASIC_LIMIT";
    OrderLeverageType["TempLimit"] = "LEVERAGE_TYPE_TEMP_LIMIT";
    OrderLeverageType["DayTrade"] = "LEVERAGE_TYPE_DAY_TRADE";
})(OrderLeverageType || (OrderLeverageType = {}));
var _obj;
var ForcedSellMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.DebtRatio, "FORCED SELL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.TimeLimit, "FORCED SELL"), _obj);
var ActionTarget;
(function(ActionTarget) {
    ActionTarget["UNSPECIFIED"] = "ACTION_TARGET_UNSPECIFIED";
    ActionTarget["REGULAR"] = "ACTION_TARGET_REGULAR";
    ActionTarget["DAY_TRADE"] = "ACTION_TARGET_DAY_TRADE";
    ActionTarget["LEGACY_SMARTORDER"] = "ACTION_TARGET_LEGACY_SMARTORDER";
    ActionTarget["TRAILING_STOP"] = "ACTION_TARGET_TRAILING_STOP";
    ActionTarget["STOP_ORDER"] = "ACTION_TARGET_STOP_ORDER";
    ActionTarget["BRACKET_ORDER"] = "ACTION_TARGET_BRACKET_ORDER";
})(ActionTarget || (ActionTarget = {}));


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 90668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var global_ModalShare__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41232);
/* harmony import */ var lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10707);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(333);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(56266);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30627);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86123);
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99093);
/* harmony import */ var utils_source__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9486);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50700);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97986);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47225);
/* harmony import */ var _tests_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18278);
/* eslint-disable no-unused-vars */ 























var LS_TOOLTIP_SHARE = "tooltipShare";
function Footer(param) {
    var post = param.post, onComment = param.onComment, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideLikers = param.hideLikers, hideLikers = _hideLikers === void 0 ? false : _hideLikers, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost;
    var pageSource = (0,utils_source__WEBPACK_IMPORTED_MODULE_15__/* .getAnalyticsPageSource */ .u)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__/* .selectors */ .wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(LS_TOOLTIP_SHARE), showShareTolltip = ref1.showTooltip, onCloseShareTooltip = ref1.onCloseTooltip;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalShare = ref2[0], showModalShare = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalTipping = ref4[0], showModalTipping = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalLike = ref5[0], showModalLike = ref5[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    // TODO: handle logic in footer
    /**
   * - Handle like post -> button after liked/unliked (DONE)
   * - Open modal conversation
   * - Hide tipjar icon if post.userid === current userid
   */ var handleLikePost = function() {
        var action = liked ? _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.unlikePost */ .Sz.unlikePost : _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.likePost */ .Sz.likePost;
        // @ts-ignore
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chatData) {
            var send, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__/* .effects.sendBulkChat */ .Sz.sendBulkChat((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShare = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickShareButton */ .ZP.common.Action.clickShareButton(pageSource);
        }
        showModalShare(true);
    };
    var handleClickTip = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickTipping */ .ZP.common.Action.clickTipping({
                pageSource: pageSource,
                streamId: post.postid,
                userId: post.userid
            });
        }
        showModalTipping(true);
    };
    var urlToShare = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_17__/* .FooterContainer */ .bk, {
        className: "stream-footer-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    !hideLikers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: likes > 0 && "".concat(likes, " likes")
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                            onClick: handleLikePost,
                                            "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON_COMPANY */ .KL : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON */ .l,
                                            children: liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    placement: "top",
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light,
                                        family: "bold",
                                        size: "12px",
                                        height: "22px",
                                        onClick: onCloseShareTooltip,
                                        children: "Share to friends"
                                    }),
                                    defaultVisible: showShareTolltip && isFirstPost,
                                    visible: showShareTolltip && isFirstPost,
                                    overlayClassName: "tooltip-overlay-green",
                                    overlayInnerStyle: {
                                        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary,
                                        padding: "6px 8px"
                                    },
                                    zIndex: 99,
                                    arrowPointAtCenter: true,
                                    onVisibleChange: function(open) {
                                        return onCloseShareTooltip();
                                    },
                                    getPopupContainer: function() {
                                        return(// @ts-expect-error
                                        document.getElementsByClassName("stream-footer-container")[0]);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                        onClick: handleClickShare,
                                        "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON_COMPANY */ .H9 : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON */ .On,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: "/icon/post-stream/share.svg",
                                            alt: "Share post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray,
                                    hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: handleClickTip,
                                "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON_COMPANY */ .tJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON */ .vI,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: onComment,
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    },
                                    "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON_COMPANY */ .dJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON */ .Vi
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ModalShare__WEBPACK_IMPORTED_MODULE_9__["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalInsight */ .eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalTipping */ .MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalLike */ .gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);




function PinnedLabel(param) {
    var isCompanyPinnedPost = param.isCompanyPinnedPost, _text = param.text, text = _text === void 0 ? "Pinned Post" : _text, _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "16px" : _marginBottom;
    var color = isCompanyPinnedPost ? "#858585" : "#e32072";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        // @ts-expect-error
        ml: isCompanyPinnedPost ? "0px" : "50px",
        align: "center",
        mb: marginBottom,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "icon-toolbar_pinned",
                    size: "16px",
                    color: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ml: isCompanyPinnedPost ? "4px" : "8px",
                color: color,
                children: isCompanyPinnedPost ? "Pinned Post by Stockbit" : text
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PinnedLabel);


/***/ }),

/***/ 3841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/Comment.tsx














function Comment(_param) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    var avatar = comment.avatar, content = comment.content, maskedHtml = comment.mask_html, username = comment.username, created = comment.created_display, official = comment.official, isVerified = comment.is_verified, privilege = comment.user_priv;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    // Note :
    // From backend in stream post the type of official param is number
    // but stream post inside the last_reply have official param type string
    var isOfficial = official > 0 || isVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentContainer */.bQ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            size: "x-small",
                            padding: "0 10px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(username),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                                family: "bold",
                                                size: "14px",
                                                children: username
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                            deprecatedVerifiedStatus: isOfficial,
                                            verifiedStatus: comment === null || comment === void 0 ? void 0 : comment.verified_status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                            privilege: privilege
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                    size: "12px",
                                    color: color/* default.midgray */.Z.midgray,
                                    children: created
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                    content: content,
                    maskedHtml: maskedHtml,
                    style: {
                        marginBottom: "0px"
                    },
                    needParsed: false
                })
            ]
        })
    }));
}
/* harmony default export */ var Post_Comment = (Comment);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Footer.tsx
var Footer = __webpack_require__(90668);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/index.tsx
/* eslint-disable react/require-default-props */ /* eslint-disable indent */ /* eslint-disable camelcase */ 





















var GuestFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4597).then(__webpack_require__.bind(__webpack_require__, 4597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4597)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FollowingActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 81895).then(__webpack_require__.bind(__webpack_require__, 81895));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81895)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
function Post(param) {
    var post = param.post, onComment = param.onComment, _pinned = param.pinned, pinned = _pinned === void 0 ? false : _pinned, _showLatestComment = param.showLatestComment, showLatestComment = _showLatestComment === void 0 ? true : _showLatestComment, _hasFollowingActivity = param.hasFollowingActivity, hasFollowingActivity = _hasFollowingActivity === void 0 ? true : _hasFollowingActivity, _expandContent = param.expandContent, expandContent = _expandContent === void 0 ? false : _expandContent, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint, dataCyName = param.dataCyName;
    var ref, ref1;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, last_reply = post.last_reply, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, followingActivity = post.following_activity, isAuthor = post.is_author;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var showFollowingActivity = (followingActivity === null || followingActivity === void 0 ? void 0 : (ref1 = followingActivity.users) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && hasFollowingActivity;
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamBoxContainer */.Vj, {
        "data-cy": dataCyName,
        children: [
            pinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                isCompanyPinnedPost: entryPoint === "symbol"
            }),
            showFollowingActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingActivity, {
                data: followingActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                post: post,
                isLoggedIn: isLoggedIn,
                entryPoint: entryPoint,
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    (polling === null || polling === void 0 ? void 0 : polling.length) && isLoggedIn > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: isSinglePost,
                        isTextDefaultExpand: expandContent,
                        highlightWord: highlightWord
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextContainer */.lU, {
                                children: [
                                    title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                        title: title,
                                        highlightWord: highlightWord,
                                        titleUrl: titleurl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                        content: content,
                                        maskedHtml: mask_html,
                                        isDefaultExpand: expandContent,
                                        highlightWord: highlightWord
                                    }),
                                    post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: post.newsfeed_label,
                                                src: post.newsfeed_img,
                                                style: {
                                                    width: "16px",
                                                    marginRight: "8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "12px",
                                                children: post.newsfeed_label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imagesData,
                                frameType: image_frame_type,
                                isSinglePost: isSinglePost
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: content_original,
                                autoplay: autoplayYoutube
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    reposted > 0 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        post: post,
                        onComment: onComment,
                        isFirstPost: isFirstPost,
                        symbol: symbol
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestFooter, {
                        post: post
                    })
                ]
            }),
            isLoggedIn && showLatestComment && last_reply && Object.keys(last_reply).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Comment, {
                comment: last_reply,
                onClick: onComment
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Post = (Post);


/***/ }),

/***/ 29541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useBondOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);






var initialState = {
    selected: undefined,
    list: [],
    isLoading: false,
    isLoadingList: false
};
var useBondOrder = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetails: function loadOrderDetails(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var list, index, response, _data, order;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            list = get().list;
                            index = list.findIndex(function(data) {
                                return data.id === id;
                            });
                            if (!(index >= 0)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                selected: list[index],
                                isLoading: false
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderDetail */ .iC)(id);
                        case 9:
                            response = _ctx.sent;
                            _data = response.data, order = _data.data.order;
                            set({
                                selected: order,
                                isLoading: false
                            });
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        loadOrderList: function loadOrderList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, _data, orders;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderList */ .R0)();
                        case 4:
                            response = _ctx.sent;
                            _data = response.data, orders = _data.data.orders;
                            set({
                                list: orders,
                                isLoadingList: false
                            });
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false
                            });
                            Promise.reject(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        },
        clearSelected: function clearSelected() {
            set({
                selected: null
            });
        },
        clearList: function clearList() {
            set({
                list: []
            });
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .ZP.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 42427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useBondPreviewStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);







var initialState = {
    buy: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialBuyPreview */ .dX,
    sell: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialSellPreview */ .Bv,
    product: undefined,
    isLoading: false
};
var useBondPreviewStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadBuyPreview: /**
   * We override the response when receive unit value <= 0
   *
   * This behavior is needed to provide the initial value of the buy modal
   *
   * We will show the 0 values to the user,
   *    except the buy price `price_rate` value.
   *
   */ function loadBuyPreview(productId) {
            var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().buy.price_rate;
                            if (!(isZeroUnit && priceRate)) {
                                _ctx.next = 6;
                                break;
                            }
                            set({
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: priceRate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 6:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondBuyPreview */ .UU)({
                                product_id: productId,
                                /**
         * We will set the unit to 1 if the unit is 0 or negative value
         * So it will still calls the API without any errors
         */ unit: isZeroUnit ? 1 : unit
                            });
                        case 9:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 14;
                                break;
                            }
                            set({
                                // we store the product information
                                product: data.product,
                                isLoading: false,
                                // override response
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: data.price_rate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 14:
                            set({
                                buy: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 21;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                product: initialState.product,
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadSellPreview: function loadSellPreview(productId, acquisitionOrderId) {
            var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, availableUnit, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().sell.price.sell;
                            availableUnit = get().sell.available_units;
                            if (!(isZeroUnit && priceRate && availableUnit)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    available_units: availableUnit,
                                    // exception, price.sell is needed to show the selling price
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        sell: priceRate
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            if (productId) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Product Code is required");
                        case 9:
                            if (acquisitionOrderId) {
                                _ctx.next = 11;
                                break;
                            }
                            throw new Error("Order id is required");
                        case 11:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 14;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondSellPreview */ .QY)({
                                product_id: productId,
                                acquisition_order_id: acquisitionOrderId,
                                unit: isZeroUnit ? 1 : unit
                            });
                        case 14:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 19;
                                break;
                            }
                            set({
                                product: data.product,
                                isLoading: false,
                                // override the sell preview response with initial state
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    // exception, available unit
                                    available_units: data.available_units,
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        // except the price sell data
                                        sell: data.price.sell
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 19:
                            set({
                                sell: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 26;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 26:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useBondTransaction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73921);
/* harmony import */ var _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78311);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42427);









var initialState = {
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    productId: "",
    unit: 0,
    acquisitionOrderId: "",
    priceRate: 0,
    isLoading: false,
    isTnCAccepted: false,
    isSuccess: false
};
var useBondTransaction = (0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialState), {
        submitOrder: function submitOrder() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, isTnCAccepted, transactionType, acquisitionOrderId, buy, sell;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            ref = get(), isTnCAccepted = ref.isTnCAccepted, transactionType = ref.transactionType, acquisitionOrderId = ref.acquisitionOrderId;
                            if (isTnCAccepted) {
                                _ctx.next = 5;
                                break;
                            }
                            throw new Error("Terms and Condition is required");
                        case 5:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY)) {
                                _ctx.next = 9;
                                break;
                            }
                            buy = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().buy;
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondBuy */ .yt)({
                                price_rate: buy.price_rate,
                                product_id: buy.product.id,
                                unit: parseInt(buy.unit, 10)
                            });
                        case 9:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL)) {
                                _ctx.next = 13;
                                break;
                            }
                            sell = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().sell;
                            _ctx.next = 13;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondSell */ .OF)({
                                product_id: sell.product.id,
                                buy_order_id: acquisitionOrderId,
                                unit: sell.units,
                                price_rate: sell.price.sell
                            });
                        case 13:
                            // inform the ui layer that the transaction is success
                            set({
                                isLoading: false,
                                isSuccess: true
                            });
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                isSuccess: false
                            });
                            Promise.reject(_ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }))();
        },
        clearData: function clearData() {
            set(initialState);
        },
        setTnC: function setTnC(value) {
            set({
                isTnCAccepted: value
            });
        },
        initiateBuyTransaction: function initiateBuyTransaction(productId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadBuyPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadBuyPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadBuyPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadBuyPreview(productId)
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        initiateSellTransaction: function initiateSellTransaction(productId, acquisitionOrderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadSellPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadSellPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadSellPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                acquisitionOrderId: acquisitionOrderId,
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadSellPreview(productId, acquisitionOrderId, 1), 
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        reInitiateTransaction: function reInitiateTransaction() {
            set({
                unit: 0,
                priceRate: 0,
                isTnCAccepted: false,
                isSuccess: false
            });
        }
    });
});


/***/ }),

/***/ 81557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useBondsModalStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73921);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);
/* harmony import */ var _useBondOrder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29541);
/* harmony import */ var _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29176);
/* harmony import */ var _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55847);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42427);












var initialState = {
    isLoading: false,
    error: undefined,
    isSearchActive: false,
    isAllowedToSearch: false,
    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED,
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.UNSPECIFIED */ .Ew.UNSPECIFIED
};
var useBondsModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, initialState), {
        toggleSearch: function toggleSearch(state) {
            if (typeof state === "boolean") {
                set({
                    isSearchActive: state
                });
                return;
            }
            set(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prev), {
                    isSearchActive: !prev.isSearchActive
                });
            });
        },
        openConfirmModal: function openConfirmModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
            });
        },
        openBlockerModal: function openBlockerModal(blockerType) {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                blockerType: blockerType
            });
        },
        openTncModal: function openTncModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC
            });
        },
        openCouponReceipt: function openCouponReceipt(orderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, couponHistories, loadPortfolioDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState(), couponHistories = ref.couponHistories, loadPortfolioDetails = ref.loadPortfolioDetails;
                            if (couponHistories) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return loadPortfolioDetails(orderId, true);
                        case 4:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.COUPON_RECEIPT */ ._y.COUPON_RECEIPT
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderModal: function openOrderModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER */ ._y.ORDER
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderHistoryModal: function openOrderHistoryModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.HISTORY */ ._y.HISTORY
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openBuyModal: function openBuyModal(productId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateBuyTransaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            initiateBuyTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateBuyTransaction;
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.BUY */ .qB.BUY,
                                isAllowedToSearch: true,
                                sourcePage: sourcePage
                            });
                            _ctx.next = 5;
                            return initiateBuyTransaction(productId);
                        case 5:
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        openSellModal: function openSellModal(productId, orderId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateSellTransaction, loadPortfolioDetails, transactions, _transactions, transaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            // store the source page
                            if (sourcePage) {
                                set({
                                    sourcePage: sourcePage
                                });
                            }
                            if (!orderId) {
                                _ctx.next = 8;
                                break;
                            }
                            initiateSellTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateSellTransaction;
                            _ctx.next = 6;
                            return initiateSellTransaction(productId, orderId);
                        case 6:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.SELL */ .qB.SELL,
                                isAllowedToSearch: false
                            });
                            return _ctx.abrupt("return");
                        case 8:
                            loadPortfolioDetails = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().loadPortfolioDetails;
                            _ctx.next = 11;
                            return loadPortfolioDetails(productId);
                        case 11:
                            transactions = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().transactions;
                            if (!(transactions.length === 1)) {
                                _ctx.next = 19;
                                break;
                            }
                            _transactions = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(transactions, 1), transaction = _transactions[0];
                            if (!transaction.is_stable_earn) {
                                _ctx.next = 17;
                                break;
                            }
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                                blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.STABLE_EARN */ .Ew.STABLE_EARN
                            });
                            return _ctx.abrupt("return");
                        case 17:
                            get().openSellModal(productId, transaction.order_code);
                            return _ctx.abrupt("return");
                        case 19:
                            // open the assets / product selection modal
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ASSETS */ ._y.ASSETS
                            });
                            _ctx.next = 25;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        openOrderPlacedModal: function openOrderPlacedModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER_PLACED */ ._y.ORDER_PLACED
            });
        },
        reOpenTransactionModal: function reOpenTransactionModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
            });
        },
        closeModal: function closeModal() {
            var ref = get(), modalType = ref.modalType, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            if (isSearchActive) {
                toggleSearch();
            }
            if (modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC) {
                // back to confirmation
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
                });
                return;
            }
            // back to the transaction
            var product = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState().product;
            var isBackToTransaction = modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION;
            if (isBackToTransaction && product) {
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
                });
                return;
            }
            // Close the modal
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED
            });
        },
        closeTransactionModal: function closeTransactionModal() {
            var ref = get(), closeModal = ref.closeModal, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            var clearData = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().clearData;
            var ref1 = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState(), clearPreview = ref1.clear;
            var clearPortfolioList = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().clearPortfolioList;
            if (isSearchActive) {
                toggleSearch();
            }
            clearPreview();
            clearPortfolioList();
            clearData();
            closeModal();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 78311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useCashOnHandStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);






var initialState = {
    cashOnHand: 0,
    isLoading: false
};
var useCashOnHandStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadBalance: function loadBalance() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__/* .getCashOnHand */ .S)();
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                cashOnHand: data.available_cash_on_hand
                            });
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    formType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined,
    setToMaxLot: false,
    isGtc: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 71534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52288);
/* harmony import */ var lib_api_chat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69101);
/* harmony import */ var global_GlobalModalManager_stores_useGlobalModalStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14467);
/* harmony import */ var global_GlobalModalManager_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30682);
/* harmony import */ var features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63576);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86123);
/* harmony import */ var config_requestTrading_errorHandler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22537);














function useChat() {
    var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var setActiveModal = (0,global_GlobalModalManager_stores_useGlobalModalStore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(s) {
        return s.setActiveModal;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), fetchingEligibility = ref[0], setFetchingEligibility = ref[1];
    var checkEligibility = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(uname, showLoading) {
            var eligibility;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (showLoading) setFetchingEligibility(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* .getChatEligibility */ .r4)(uname);
                    case 4:
                        eligibility = _ctx.sent;
                        if (showLoading) setFetchingEligibility(false);
                        return _ctx.abrupt("return", eligibility.data.data.is_eligible);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,config_requestTrading_errorHandler__WEBPACK_IMPORTED_MODULE_10__/* .handleShowAlertMessage */ .Ye)(_ctx.t0);
                        return _ctx.abrupt("return", true);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function checkEligibility(uname, showLoading) {
            return _ref.apply(this, arguments);
        };
    }();
    var redirectChat = function(uname, target) {
        var q = {};
        if (uname) {
            q = {
                n: uname
            };
        }
        if (source === "main-profile") {
            q = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, q), {
                source: features_chat_constant__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_CHAT_ROOM_VIEWED.findIndex */ .VY.findIndex(function(item) {
                    return item === "User Profile";
                })
            });
        }
        var query = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(q);
        query = query ? "?".concat(query) : "";
        if (target === "_self") {
            router.push("/chat".concat(query));
        } else {
            window.open("".concat(constants_app__WEBPACK_IMPORTED_MODULE_9__/* .PROJECT_FOLDER_PATH */ .qV, "/chat").concat(query), target);
        }
    };
    var openChatLimit = function() {
        setActiveModal(global_GlobalModalManager_types__WEBPACK_IMPORTED_MODULE_6__/* .GlobalModalType.ChatLimit */ .C.ChatLimit);
    };
    var openChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(props) {
            var username, _target, target, onEligible, onIneligible, is_eligible;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = props.username, _target = props.target, target = _target === void 0 ? "_blank" : _target, onEligible = props.onEligible, onIneligible = props.onIneligible;
                        setFetchingEligibility(true);
                        if (source === "main-profile") {
                            features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .mainProfileEvents.onUserProfileChatSelected */ .j4.onUserProfileChatSelected();
                        }
                        _ctx.next = 5;
                        return checkEligibility(username);
                    case 5:
                        is_eligible = _ctx.sent;
                        setFetchingEligibility(false);
                        if (is_eligible) {
                            onEligible === null || onEligible === void 0 ? void 0 : onEligible();
                            redirectChat(username, target);
                        } else {
                            onIneligible === null || onIneligible === void 0 ? void 0 : onIneligible();
                            openChatLimit();
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function openChat(props) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        isFetching: fetchingEligibility,
        openChat: openChat,
        checkEligibility: checkEligibility,
        redirectChat: redirectChat,
        openChatLimit: openChatLimit
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useChat);


/***/ }),

/***/ 97486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, setCharAt, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25516);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 




/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
/**
 * @deprecated - do not use for user input manipulation
 * @param {} str
 * @param {*} match
 * @param {*} replacement
 * @returns str
 */ function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary;
    if (Number(number) < 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        ;
        return constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O;
    }
}



/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19225);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ }),

/***/ 89237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ convertSmartOrderConfigType; },
/* harmony export */   "KH": function() { return /* binding */ convertSecuritiesKind; },
/* harmony export */   "TQ": function() { return /* binding */ lotFormatter; },
/* harmony export */   "a$": function() { return /* binding */ getExercisedData; },
/* harmony export */   "aF": function() { return /* binding */ getHourFromTimestamp; },
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "y0": function() { return /* binding */ convertBooleanToNumber; },
/* harmony export */   "zn": function() { return /* binding */ convertForceSellEvent; }
/* harmony export */ });
/* unused harmony exports formatToLocalDate, convertGoogleDateToTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78343);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91037);


var HOUR_OFFSET = -7;
var convertBooleanToNumber = function(bool) {
    return bool ? 1 : 0;
};
var formatToLocalDate = function(date, customFormat) {
    var adjustedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, HOUR_OFFSET);
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(adjustedDate, customFormat);
    return formattedHour;
};
var convertTimestampToDate = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "yyyy-MM-dd HH:mm:ss");
};
var convertGoogleDateToTimestamp = function(date) {
    if (!date) return "";
    var year = date.year, month = date.month, day = date.day;
    var jsDate = new Date(year, month - 1, day + 1);
    return formatToLocalDate(jsDate, "dd-MM-yyyy");
};
var getHourFromTimestamp = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "HH:mm:ss");
};
var getTime = function(timestamp) {
    if (!timestamp) return "";
    return Number(timestamp.seconds) * 1000;
};
var getExercisedData = function(exercise) {
    if (!exercise) return null;
    var active = exercise.active, type = exercise.type, price = exercise.price, info = exercise.info, date = exercise.date;
    return {
        active: active,
        type: type,
        price: price,
        info: info,
        listing_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.listing),
        expired_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.expired),
        mature_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.mature),
        exercise_start_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.start),
        exercise_end_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.end)
    };
};
var convertForceSellEvent = function(event) {
    switch(event){
        case 1:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.DebtRatio */ .pD.DebtRatio;
        case 2:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.TimeLimit */ .pD.TimeLimit;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.Unspecified */ .pD.Unspecified;
    }
};
var convertSmartOrderConfigType = function(configType) {
    switch(configType){
        case "CONFIG_PRICE_TYPE_ABOVE":
            return "1";
        case "CONFIG_PRICE_TYPE_BELOW":
            return "2";
        default:
            return configType;
    }
};
var convertSecuritiesKind = function(kind) {
    switch(kind){
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.STOCK */ .pY.STOCK:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Stock */ .IC.Stock;
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.BOND */ .pY.BOND:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Bond */ .IC.Bond;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Unspecified */ .IC.Unspecified;
    }
};
var lotFormatter = function(value) {
    return Intl.NumberFormat("en-US").format(value);
};


/***/ }),

/***/ 75413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ convertSideToAction; },
/* harmony export */   "I_": function() { return /* binding */ smartOrderLabelTag; },
/* harmony export */   "Sp": function() { return /* binding */ smartOrderLabelText; }
/* harmony export */ });
/* harmony import */ var utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89237);
/* harmony import */ var global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75626);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91037);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83153);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2078);





var convertSideToAction = function(side) {
    return side === global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__/* .OrderSide.Buy */ .oU.Buy ? global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .i.Buy : global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .i.Sell;
};
var smartOrderLabelTag = {
    SMART_ORDER_LABEL_TYPE_UNSPECIFIED: "",
    SMART_ORDER_LABEL_TYPE_AUTO_BUY: "AB",
    SMART_ORDER_LABEL_TYPE_STOP_LOSS: "SL",
    SMART_ORDER_LABEL_TYPE_TAKE_PROFIT: "TP",
    SMART_ORDER_LABEL_TYPE_TRAILING_STOP: "TS",
    SMART_ORDER_LABEL_TYPE_LIMIT_IF_TOUCHED: "LIT",
    SMART_ORDER_LABEL_TYPE_BRACKET_ORDER: "BO",
    // TODO: currently placeholder, please update when API is ready
    SMART_ORDER_LABEL_TYPE_VOLUME_TRIGGER_ORDER: ""
};
var smartOrderLabelText = {
    SMART_ORDER_LABEL_TYPE_UNSPECIFIED: "",
    SMART_ORDER_LABEL_TYPE_AUTO_BUY: "Auto Buy",
    SMART_ORDER_LABEL_TYPE_STOP_LOSS: "Stop Loss",
    SMART_ORDER_LABEL_TYPE_TAKE_PROFIT: "Take Profit",
    SMART_ORDER_LABEL_TYPE_TRAILING_STOP: "Trailing Stop",
    SMART_ORDER_LABEL_TYPE_LIMIT_IF_TOUCHED: "Limit If Touched",
    SMART_ORDER_LABEL_TYPE_BRACKET_ORDER: "Bracket Order",
    // TODO: currently placeholder, please update when API is ready
    SMART_ORDER_LABEL_TYPE_VOLUME_TRIGGER_ORDER: ""
};
var sortBracketOrder = function(a, b) {
    if (a.label === "SMART_ORDER_LABEL_TYPE_STOP_LOSS") return -1;
    if (b.label === "SMART_ORDER_LABEL_TYPE_STOP_LOSS") return 1;
    return 0;
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, type = ref.type, info = ref.info, bond = ref.bond, can_create_smart_order = ref.can_create_smart_order, is_sharia = ref.is_sharia;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(flags === null || flags === void 0 ? void 0 : flags.allow_order),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getExercisedData */ .a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.have_smart_order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stock_on_hand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.market_value,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profit_loss,
        type: type !== null && type !== void 0 ? type : "",
        info: info !== null && info !== void 0 ? info : [],
        bond: bond !== null && bond !== void 0 ? bond : undefined,
        show_create_smartorder: can_create_smart_order !== null && can_create_smart_order !== void 0 ? can_create_smart_order : false,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.can_buy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.can_sell,
        is_sharia: is_sharia
    };
};
var portfolioItemFromBonds = function(data) {
    var ref, ref1, ref2, ref3;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(true),
        amount_invested: data === null || data === void 0 ? void 0 : data.invested_amount,
        available_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        available_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        company_name: data.product.name,
        exercise_data: undefined,
        exercise_type: undefined,
        have_smartorder: false,
        price_average: data === null || data === void 0 ? void 0 : data.price_rate,
        price_average_fee: data === null || data === void 0 ? void 0 : data.price_rate,
        price_latest: undefined,
        stock_on_hand: data === null || data === void 0 ? void 0 : data.invested_amount,
        symbol: data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.identifier,
        total: data === null || data === void 0 ? void 0 : data.total_portfolio,
        unrealised_gain: (data === null || data === void 0 ? void 0 : (ref1 = data.profit_loss) === null || ref1 === void 0 ? void 0 : ref1.percentage) / 100,
        unrealised_marketvalue: data === null || data === void 0 ? void 0 : data.market_value,
        unrealised_profitloss: data === null || data === void 0 ? void 0 : (ref2 = data.profit_loss) === null || ref2 === void 0 ? void 0 : ref2.amount,
        type: constants_trading__WEBPACK_IMPORTED_MODULE_3__/* .STOCK_TYPE.bond */ .L2.bond,
        info: undefined,
        bond: undefined,
        show_create_smartorder: false,
        bond_sell_enabled: parseInt(data === null || data === void 0 ? void 0 : data.units, 10) > 0,
        is_sharia: data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.is_sharia,
        can_buy: false,
        can_sell: false
    };
};
var portfolioList = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref.summary, smart_order_info = ref.smart_order_info, stockPortfolios = ref.results, day_trade = ref.day_trade;
    var result = stockPortfolios.map(function(stockPortfolio) {
        return portfolioItem(stockPortfolio);
    });
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : summary.trading.balance,
        amount_allocated: summary === null || summary === void 0 ? void 0 : summary.amount.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : summary.amount.credit_limit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.realised,
        show_create_smartorder: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.can_create,
        auto_order_info: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.info,
        day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.map(function(item) {
            return portfolioItem(item);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : summary.debt.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : summary.debt.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : summary.debt.market_value,
        amount_invested: summary === null || summary === void 0 ? void 0 : summary.amount.invested,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.net,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        result: result
    };
};
var orderDetail = function(order) {
    var ref;
    var ref1 = order !== null && order !== void 0 ? order : {}, action = ref1.action, amount = ref1.amount, day_trade = ref1.day_trade, gtc = ref1.gtc, market_order_id = ref1.market_order_id, message = ref1.message, order_id = ref1.order_id, price = ref1.price, qty = ref1.qty, side = ref1.side, securities_kind = ref1.securities_kind, smart_order = ref1.smart_order, status_text = ref1.status_text, symbol = ref1.symbol, time = ref1.time, is_sharia = ref1.is_sharia, platform_order_type = ref1.platform_order_type, leverage_type = ref1.leverage_type;
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var isFAK = platform_order_type === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__/* .PlatformOrderTypes.FAK */ .F4.FAK;
    var gtc_text = "DAY";
    if (isFAK) gtc_text = "FAK";
    else if (gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc) gtc_text = "GTC";
    var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    return {
        action: convertSideToAction(side),
        amend_target: action === null || action === void 0 ? void 0 : action.amend_target,
        amend_action: action.amend_target !== "ACTION_TARGET_UNSPECIFIED" || (action === null || action === void 0 ? void 0 : action.can_amend),
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: isBond ? undefined : amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matched_total,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_target: action === null || action === void 0 ? void 0 : action.cancel_target,
        cancel_action: action.cancel_target !== "ACTION_TARGET_UNSPECIFIED" || (action === null || action === void 0 ? void 0 : action.can_cancel),
        config_type: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertSmartOrderConfigType */ .Hc)(smart_order === null || smart_order === void 0 ? void 0 : smart_order.config_type),
        gtc_text: gtc_text,
        gtc: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc),
        label: isFAK ? "MO" : smart_order === null || smart_order === void 0 ? void 0 : smart_order.label,
        market_orderid: market_order_id,
        message: message,
        order_done: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_done,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lot_open,
        order_total: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_total,
        orderid: order_id,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_average_portfolio: price === null || price === void 0 ? void 0 : price.average.portfolio,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: (ref2 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.order_id) !== null && ref2 !== void 0 ? ref2 : smart_order === null || smart_order === void 0 ? void 0 : smart_order.id,
        smart_order_bracket_order_child: (ref3 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.bracket_order_children.sort(sortBracketOrder)) !== null && ref3 !== void 0 ? ref3 : [],
        smart_order_parent_id: (ref4 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.parent_id) !== null && ref4 !== void 0 ? ref4 : "",
        smart_order_parent_price: (ref5 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.parent_price) !== null && ref5 !== void 0 ? ref5 : 0,
        status: status_text,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getHourFromTimestamp */ .aF)((ref6 = time === null || time === void 0 ? void 0 : time.open) !== null && ref6 !== void 0 ? ref6 : time === null || time === void 0 ? void 0 : time.opened_at),
        time_match: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref7 = time === null || time === void 0 ? void 0 : time.match) !== null && ref7 !== void 0 ? ref7 : time === null || time === void 0 ? void 0 : time.matched_at),
        time_open: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref8 = time === null || time === void 0 ? void 0 : time.open) !== null && ref8 !== void 0 ? ref8 : time === null || time === void 0 ? void 0 : time.opened_at),
        trigger_price: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trigger_price,
        day_trade_is_day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.is_day_trade,
        day_trade_force_sell_event: day_trade === null || day_trade === void 0 ? void 0 : day_trade.force_sell_event,
        day_trade_message: (ref9 = day_trade === null || day_trade === void 0 ? void 0 : day_trade.message) !== null && ref9 !== void 0 ? ref9 : "",
        is_sharia: is_sharia,
        trailing_stop: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trailing_stop,
        platform_order_type: platform_order_type,
        leverage_type: leverage_type
    };
};
var orderList = function(orders) {
    var mappedData = orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    }).filter(function(order) {
        return order.smart_order_parent_id === "";
    });
    return mappedData;
};
var formulaData = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, version = ref.version, formula = ref.formula, fee = ref.fee, preview_fee = ref.preview_fee, day_trade = ref.day_trade;
    var dayTradePreviewFee = (day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee) ? day_trade.preview_fee : preview_fee;
    return {
        version: version,
        fee: {
            buy: fee.buy,
            sell: fee.sell
        },
        formula: {
            buy_amount_broker_fee: formula.buy.broker_fee,
            buy_amount_exchange_fee: formula.buy.exchange_fee,
            buy_amount_fee: formula.buy.fee,
            buy_amount_invested: formula.buy.invested,
            buy_amount_invested_fee: formula.buy.invested_fee,
            ca_sell_amount_broker_fee: formula.ca_sell.broker_fee,
            ca_sell_amount_exchange_fee: formula.ca_sell.exchange_fee,
            ca_sell_amount_fee: formula.ca_sell.fee,
            ca_sell_amount_invested: formula.ca_sell.invested,
            ca_sell_amount_invested_fee: formula.ca_sell.invested_fee,
            sell_amount_broker_fee: formula.sell.broker_fee,
            sell_amount_exchange_fee: formula.sell.exchange_fee,
            sell_amount_fee: formula.sell.fee,
            sell_amount_invested: formula.sell.invested,
            sell_amount_invested_fee: formula.sell.invested_fee,
            sell_gain: formula.sell_gain,
            sell_profit_loss: formula.sell_profit_loss,
            amount_invested: formula.amount_invested,
            summary_equity: formula.summary.equity,
            summary_invested: formula.summary.invested,
            summary_net_profit_loss: formula.summary.net_profit_loss.value,
            summary_net_profit_loss_percentage: formula.summary.net_profit_loss.percentage,
            unrealised_gain: formula.unrealized.gain,
            unrealised_market_value: formula.unrealized.market_value,
            unrealised_profit_loss: formula.unrealized.profit_loss,
            day_trade_debt_ratio: formula.day_trade.debt.ratio,
            day_trade_debt_unrealized: formula.day_trade.debt.unrealized,
            day_trade_portion_order_amount: formula.day_trade.portion_order_amount,
            day_trade_investment_day_trade: formula.day_trade.investment.day_trade,
            day_trade_investment_portion_tb: formula.day_trade.investment.portion_tb,
            fee_buy: fee.buy,
            fee_sell: fee.sell,
            fee_buy_day_trade: day_trade.fee.buy,
            fee_sell_day_trade: day_trade.fee.sell
        },
        preview_fee: {
            broker_fee: preview_fee.broker_fee,
            exchange: {
                compositions: preview_fee.exchange.compositions,
                title: preview_fee.exchange.title,
                desc: preview_fee.exchange.desc,
                subtitle: preview_fee.exchange.subtitle,
                exchange_fee_total_buy: preview_fee.exchange.total_buy,
                exchange_fee_total_ca_buy: preview_fee.exchange.total_ca_buy,
                exchange_fee_total_ca_sell: preview_fee.exchange.total_ca_sell,
                exchange_fee_total_sell: preview_fee.exchange.total_sell,
                exchange_fee_total_title: preview_fee.exchange.total_title
            }
        },
        day_trade: {
            fee: {
                buy: day_trade.fee.buy,
                sell: day_trade.fee.sell
            },
            portion_deduct_to_tb: day_trade.portion_deduct_to_tb,
            preview_fee: {
                broker_fee: dayTradePreviewFee.broker_fee,
                exchange: {
                    compositions: dayTradePreviewFee.exchange.compositions,
                    title: dayTradePreviewFee.exchange.title,
                    desc: dayTradePreviewFee.exchange.desc,
                    subtitle: dayTradePreviewFee.exchange.subtitle,
                    exchange_fee_total_buy: dayTradePreviewFee.exchange.total_buy,
                    exchange_fee_total_ca_buy: dayTradePreviewFee.exchange.total_ca_buy,
                    exchange_fee_total_ca_sell: dayTradePreviewFee.exchange.total_ca_sell,
                    exchange_fee_total_sell: dayTradePreviewFee.exchange.total_sell,
                    exchange_fee_total_title: dayTradePreviewFee.exchange.total_title
                }
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList,
    formulaData: formulaData,
    portfolioItemFromBonds: portfolioItemFromBonds
});


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ }),

/***/ 58080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ isAllowedToBlockIp; },
/* harmony export */   "Rg": function() { return /* binding */ getUserRole; },
/* harmony export */   "_W": function() { return /* binding */ isAllowedToManageTop; },
/* harmony export */   "w1": function() { return /* binding */ isAllowedToSuspend; },
/* harmony export */   "xj": function() { return /* binding */ UserRoleName; }
/* harmony export */ });
/* unused harmony exports isAllowedToDelete, isAllowedToMultiDelete */
var UserRole = [
    "MEMBER",
    "ADMIN",
    "MODERATOR",
    "CONFIGURATOR",
    "SUPER_ADMIN", 
];
var UserRoleName = {
    MEMBER: "Member",
    ADMIN: "ADMIN",
    MODERATOR: "ADMIN",
    CONFIGURATOR: "CONFIGURATOR",
    SUPER_ADMIN: "ADMIN"
};
var checkPrivilege = function(userPriv, allowed) {
    return allowed.indexOf("".concat(userPriv)) >= 0;
};
var isAllowedToDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToMultiDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToSuspend = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToBlockIp = function(userPriv) {
    return checkPrivilege(userPriv, [
        "4"
    ]);
};
var isAllowedToManageTop = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "4"
    ]);
};
var getUserRole = function(userPriv) {
    if (!checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ])) {
        return "";
    }
    var role = UserRole[userPriv];
    return UserRoleName[role];
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UserRole)));


/***/ })

}]);